import {Component} from '@angular/core';
import {ColumnFilter, DataTableColumnData, DataTableConfig, DataTableObservableDataSource, ProjectApiService, TableAction} from '@cas-hub/acabim-common-client';
import {DataExportRequest} from '../../../../_models/data-export.model';
import {DataExportService} from '../../../../_services/data-export.service';

@Component({
    selector: 'acabim-admin-view-export-requests',
    templateUrl: './view-export-requests.component.html',
    styleUrls: ['./view-export-requests.component.scss']
})
export class ViewExportRequestsComponent {

    public readonly dataExportDataSource: DataExportRequestDataSource[];

    constructor(public readonly projectApiService: ProjectApiService,
                dataExportService: DataExportService) {
        this.dataExportDataSource = [new DataExportRequestDataSource(dataExportService)];
    }

    public onNewRequestCreated(req: DataExportRequest): void {
        this.dataExportDataSource[0].rowData.push(req);
    }
}

class DataExportRequestDataSource extends DataTableObservableDataSource<DataExportRequest> {

    public columnFilters: ColumnFilter[] = [];
    public readonly actions: TableAction[] = [{id: 0, name: 'Download'}];
    public readonly columnData: DataTableColumnData[] = [
        {displayName: 'Request Type', objectPropertyName: 'Building Data'}, // Temporary
        {displayName: 'Requested Date', objectPropertyName: 'requestedDate'},
        {displayName: 'State', objectPropertyName: 'state'}
    ];

    public readonly config: DataTableConfig = {
        globalFilterFields: [],
        hasActions: true,
        hasCheckbox: true,
        hasDetailsButton: false,
        hasFilters: false,
        isExportEnabled: false,
        isLazyLoadingEnabled: false,
        isPaginationEnabled: false,
        isSearchEnabled: false,
        searchPlaceHolder: 'No export requests found',
        tableHeading: 'Data Export Requests'
    };

    public constructor(private readonly dataExportService: DataExportService) {
        super(() => {
            return dataExportService.getCurrentRequests();
        });
    }

    public onAction(action: TableAction): void {
        if (this.selectedData.length) {
            const completedItems = this.selectedData.filter(d => d.state === 'Completed');
            if (completedItems && completedItems.length) {
                this.dataExportService.getDownloadUrl(completedItems[0].exportRequestId).subscribe(url => {
                    if (url) {
                        window.location.href = url;
                    }
                });
            }
        }
    }

    public onDataExpanded(value: DataExportRequest): void {
    }

    public onDataFiltered(): void {
    }
}
